import { useState } from 'react';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import {
  CARD_COLOR_OPTIONS,
  type CardColorMode,
  toCardColorMode,
  toExperienceColorMode,
} from '../cardColorMode';
import { SidebarSection } from '../SidebarKit';
import { useCustomizeControl } from '../useCustomizeControl';
import { CardGallery } from './CardGallery';
import { SegmentedControl } from './SegmentedControl';

export const CardStyleSection = () => {
  const { persistedExperience } = usePageExperienceContext();
  const { register } = useCustomizeControl();

  const { onPreview, ...cardColorMode } = register<'colorMode', CardColorMode>(
    'experience',
    'colorMode',
    { toControl: toCardColorMode, toField: toExperienceColorMode }
  );

  // The samples sit under the cursor while the page previews behind the
  // sidebar, so they follow the hover too rather than holding the saved mode.
  const [hoveredMode, setHoveredMode] = useState<CardColorMode | null>(null);

  return (
    <SidebarSection label="Card style" scope="For views with cards">
      <SegmentedControl
        options={CARD_COLOR_OPTIONS}
        {...cardColorMode}
        onPreview={(mode) => {
          setHoveredMode(mode);
          onPreview(mode);
        }}
      />
      <CardGallery
        mode={hoveredMode ?? cardColorMode.value}
        paletteId={persistedExperience.colorPalette}
      />
    </SidebarSection>
  );
};
